import { useEffect } from "react";
//Components
import SidebarItem from "./SidebarItem";
//Hooks
import useAuth from "../../hooks/useAuth";
//Constants
import Roles from "../../constants/Roles";

const Sidebar = ({ open, setOpen }) => {
  const { auth } = useAuth();

  useEffect(() => {
    if (open) {
      document.querySelector("#sidebar").classList.add("open");
      document.querySelector("#hamburger-1").classList.add("is-active");
    } else {
      document.querySelector("#sidebar").classList.remove("open");
      document.querySelector("#hamburger-1").classList.remove("is-active");
    }
  }, [open]);

  const handleClick = () => {
    setOpen((prev) => !prev);
  };

  const adminLinks = [
    {
      title: "Üyeler",
      link: "panel",
    },
    {
      title: "Geri Bildirimler",
      link: "feedbacks",
    },
    {
      title: "Şikayetler",
      link: "reports",
    },
    {
      title: "Bildirim Gönder",
      link: "notifications",
    },
    {
      title: "Banner",
      link: "banners",
    },
  ];

  return (
    <div className="sidebar_container" id="sidebar">
      <h1 class="sidebar_title">Çekmece</h1>
      <div class="hamburger" id="hamburger-1" onClick={handleClick}>
        <span class="line"></span>
        <span class="line"></span>
        <span class="line"></span>
      </div>
      <div className="sidebar_items_contaier">
        {auth.roles.includes(Roles.Admin)
          ? adminLinks.map((item) => (
              <SidebarItem item={item} key={item.title} />
            ))
          : null}
      </div>
    </div>
  );
};

export default Sidebar;
